export const AGENCY = 'agency';
export const TRAVEL_ARRANGER = 'travelArrenger';
export const TRAVEL_ARRANGEMENT_CLIENTS = 'travelArrangementClients';
export const NOTIFICATION = 'notification';
export const AGENCY_NOTIFICATIONS = 'agencyNotifications';
